// import router from '@iez/core/router'
import Vue from 'vue'
import {
  directive,
  /* onBeforeGuard */
} from './lib/'

export default {
  setup () {
    Vue.use(directive)
    // router.beforeEach(onBeforeGuard)
  }
}
